<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <PriceTemplateList :priceTemplateList="GetPriceTemplateList" @reload="loadData" />
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { apiGeneral } from '@/services/api/ApiServices';
import { PriceTemplateViewModel } from '@/services/api/ApiGeneral';
import PriceTemplateList from '@/components/priceTemplate/PriceTemplateList.vue';
@Component({
  components: {
      PriceTemplateList
  },
})
export default class PriceTemplates extends Vue {
    private priceTemplateList: PriceTemplateViewModel[] = [];
    private async created() {
        await this.loadData();
    }
    private async loadData() {
        await apiGeneral.priceTemplate_GetAll().then((data) => {
            this.priceTemplateList = data;
        });
    }
    get GetPriceTemplateList() {
        return this.priceTemplateList;
    }
}
</script>
